import * as graphql from 'generated/graphql';
import { useWorkspace } from 'packages/kakapo-ui-services/hooks/useWorkspace';

import useViewerRoles from './useUserRoles';

export function useFeaturesLoaded(): boolean {
	const { data } = graphql.useFeaturesQuery({
		variables: {
			id: useWorkspace().id,
		},
	});

	return !!data;
}

export default function useFeature(id: graphql.FeatureName): boolean {
	const viewerRoles = useViewerRoles();

	const { data } = graphql.useFeaturesQuery({
		variables: {
			id: useWorkspace().id,
		},
		fetchPolicy: 'cache-first'
	});

	const enabledFeatures = data?.workspace.features
		.filter(
			(feature) =>
				feature.status === graphql.WorkspaceFeatureStatus.Enabled ||
				(viewerRoles.isWorkspaceSuperuser &&
					feature.status === graphql.WorkspaceFeatureStatus.Superuser),
		)
		.map(({ feature }) => feature.id);

	return enabledFeatures?.includes(id) ?? false;
}

export function useFeatureDetails(id: graphql.FeatureName): { available?: boolean; loading: boolean } {
	const viewerRoles = useViewerRoles();

	const { data } = graphql.useFeaturesQuery({
		variables: {
			id: useWorkspace().id,
		},
	});

	const enabledFeatures = data?.workspace.features
		.filter(
			(feature) =>
				feature.status === graphql.WorkspaceFeatureStatus.Enabled ||
				(viewerRoles.isWorkspaceSuperuser &&
					feature.status === graphql.WorkspaceFeatureStatus.Superuser),
		)
		.map(({ feature }) => feature.id);

	if (!enabledFeatures) {
		return { loading: true };
	}

	const available = enabledFeatures.includes(id) ?? false;

	return { available, loading: false };
}
